import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { dashboardAPI } from '../lib/api';
import { useAuth } from './AuthContext';

const OverdueContext = createContext({ overdueCount: 0, refresh: () => {} });

export function OverdueProvider({ children }) {
  const { user } = useAuth();
  const [overdueCount, setOverdueCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const res = await dashboardAPI.getStats();
      setOverdueCount(res.data.overdue_tasks || 0);
    } catch {
      // silent — don't break the app
    }
  }, [user]);

  useEffect(() => {
    refresh();
    // Re-check every 5 minutes
    const interval = setInterval(refresh, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [refresh]);

  return (
    <OverdueContext.Provider value={{ overdueCount, refresh }}>
      {children}
    </OverdueContext.Provider>
  );
}

export function useOverdue() {
  return useContext(OverdueContext);
}
